import { gql } from '@apollo/client';

export const TIPS_PAGE_QUERY = gql`
  query TipsPage(
    $date: Date!, 
    $state: String!, 
    $trackName: String!, 
    $isLatest: Boolean = true, 
    $analysisTypeId: Float = 1
  ) {
    tipsPage(
      date: $date, 
      state: $state, 
      trackName: $trackName, 
      isLatest: $isLatest, 
      analysisTypeId: $analysisTypeId
    ) {
      track {
        track_id
        code
        name
        state
        type
      }
      meetingNote
      winnerPrices {
        track_median
        track_winners
        day_median
        day_winners
      }
      meetingNoteType
      trackConditions {
        weather
        trackCondition
        trackConditionNumber
        penetrometer
        rail
        comment
        prompt_id
      }
      predictedTrackConditions {
        predictedWeather
        predictedTrackCondition
        predictedTrackConditionNumber
        predictedPenetrometer
        predictionConfidence
        predictionDate
      }
      races {
        race_id
        race_number
        aiModel
        race_name
        distance
        class
        start_time
        group
        selections {
          top {
            number
            horse_name
            jockey
            trainer
            weight
            barrier
            odds
            assessedOdds
            adjustedAssessedProb
            oddsOpening
            oddsCurrent
            oddsUpdatedAt
            pick_order
            confidence
            isConsensusPick
            isStandardClaim
            topPickAgreement
            topPickSlots
            analysis {
              summary
              pros
              cons
            }
            bet_type
            bet_stake
            detailedInfo {
              horse_age
              horse_sex
              horse_sire
              horse_dam
              horse_last10
              horse_record
              horse_record_distance
              horse_record_track
              horse_record_track_distance
              horse_record_firm
              horse_record_good
              horse_record_soft
              horse_record_heavy
              horse_record_jumps
              horse_record_first_up
              horse_record_second_up
              horse_prize_money
              horse_record_synthetic
              location
              comments
            }
          }
          value {
            number
            horse_name
            jockey
            trainer
            weight
            barrier
            odds
            assessedOdds
            adjustedAssessedProb
            oddsOpening
            oddsCurrent
            oddsUpdatedAt
            confidence
            isConsensusPick
            analysis {
              summary
              pros
              cons
            }
            bet_type
            bet_stake
            detailedInfo {
              horse_age
              horse_sex
              horse_sire
              horse_dam
              horse_last10
              horse_record
              horse_record_distance
              horse_record_track
              horse_record_track_distance
              horse_record_firm
              horse_record_good
              horse_record_soft
              horse_record_heavy
              horse_record_jumps
              horse_record_first_up
              horse_record_second_up
              horse_prize_money
              horse_record_synthetic
              location
              comments
            }
          }
          speed_map
          suggested_bets {
            type
            selection
            stake
          }
          speedMap {
            fieldSize
            knownCount
            styleAvailable
            genuineLeaderCount
            likelyTempo
            tempoRationale
            runners {
              tabNumber
              barrier
              horseName
              bucket
              mapPosition
              runStyle
              settleAvg
              sampleSize
              confidence
              source
            }
          }
        }
      }
      bestBets {
        best {
          race
          number
          name
          confidence
          odds
          analysis
          stake
        }
        value {
          race
          number
          name
          confidence
          odds
          analysis
          stake
        }
      }
      scratchings {
        raceNo
        tabNo
        runnerName
        reason
      }
      hasMultipleAnalysisTypes
    }
  }
`;
